import { api } from "@/openapi/client";
import { ApiResponseError } from "@/lib/error";
import { getCacheTags } from "@/lib/cache-utils";
import type { operations, components } from "@/openapi/generated";
import { transactionQueryKeys } from "@donista/shared/query-keys/transactions";

export type GetRecentTransactionsResponse = operations["getRecentTransactions"]["responses"]["200"]["content"]["*/*"];

export type GetTransactionsRequestParameter = operations["getTransactions"]["parameters"]["query"];
export type GetTransactionsResponse = operations["getTransactions"]["responses"]["200"]["content"]["*/*"];

export type TransactionDetailPublicDto = components["schemas"]["TransactionDetailPublicDto"];
export type TransactionVersionEntry = components["schemas"]["TransactionVersionEntry"];

export { transactionQueryKeys };

export async function getRecentTransactions(): Promise<GetRecentTransactionsResponse> {
    const { data, error } = await api.GET("/transactions/recent");

    if (error) {
        throw new Error(`Failed to fetch recent transactions: ${error}`);
    }

    if (!data) {
        throw new Error("No data received from transactions API");
    }

    return data;
}

export async function getTransactions(
    query?: GetTransactionsRequestParameter,
    client: typeof api = api
): Promise<GetTransactionsResponse> {
    const { data, error } = await client.GET("/transactions", {
        params: { query },
        next: { tags: getCacheTags(transactionQueryKeys.list(query)) },
    });
    if (error) throw error;
    if (!data) throw new ApiResponseError("getTransactions");
    return data;
}
